module.exports = __webpack_public_path__ + "static/media/SleepClinic.068d18de.svg";